var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "HeartFullPath",
    d: "M0.5 7.67929C0.5 10.2722 1.81423 12.5649 3.82688 13.9554L12.4105 21.4445C13.4302 22.3342 14.9537 22.3223 15.9595 21.4169L24.592 13.6451C26.3662 12.2371 27.5001 10.0877 27.5001 7.67929C27.5001 3.43814 23.9839 0 19.6464 0C17.43 0 15.428 0.897744 14 2.34164C12.5721 0.897744 10.5701 0 8.35369 0C4.01622 0 0.5 3.43814 0.5 7.67929Z",
    fill: "#c9c9c9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0348 10.9896C9.76872 10.9896 11.1743 9.54248 11.1743 7.75737C11.1743 5.97226 9.76872 4.52515 8.0348 4.52515C6.30088 4.52515 4.89526 5.97226 4.89526 7.75737C4.89526 9.54248 6.30088 10.9896 8.0348 10.9896Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFaded);
export default __webpack_public_path__ + "static/media/heart-faded.7cc3f9daebf749b64e74d486bf2a383d.svg";
export { ForwardRef as ReactComponent };